import axios from 'axios';
import {base_api} from './base';

export function getForms(includeDeleted, includeInActive, companyId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  if (!companyId) {
    return axios.get(`${base_api}/Forms?includeDeleted=${includeDeleted}&includeInActive=${includeInActive}`, {headers});
  }
  return axios.get(`${base_api}/Forms?includeDeleted=${includeDeleted}&includeInActive=${includeInActive}&companyId=${companyId}`, {headers});
}

export function getFormById(id) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Forms/GetById?id=${id}`, {headers});
}

export function getFormByName(title) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Forms/GetByName?title=${title}`, {headers});
}

export function addForm(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Forms/AddForm`, data, {headers});
}

export function updateForm(formId, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/Forms/UpdateForm?formId=${formId}`, data, {headers});
}

export function deleteForm(id, hardDelete) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/Forms/DeleteForm?id=${id}&hardDelete=${hardDelete}`, {headers});
}

export function getLeadForms() {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Forms/GetLeadForms`, {headers});
}

export function getLeadFormByEvent(eventId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Forms/GetLeadFormByEvent?eventId=${eventId}`, {headers});
}

export function getSurveyForms() {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Forms/GetSurveyForms`, {headers});
}


export function getSubForms(includeDeleted, formId, companyId, eventId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  let route = `includeDeleted=${includeDeleted}&formId=${formId}&companyId=${companyId}&eventId=${eventId}`;
  return axios.get(`${base_api}/Forms/GetListSubForms?` + route, {headers});
}

export function getSubFormByIds(companyId, eventId, formId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  let route = `companyId=${companyId}&eventId=${eventId}&formId=${formId}`;
  return axios.get(`${base_api}/Forms/GetSubFormByIds?` + route, {headers});
}

export function addSubForm(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Forms/AddSubForm`, data, {headers});
}

export function updateSubForm(subformId, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/Forms/UpdateSubForm?subformId=${subformId}`, data, {headers});
}

export function deleteSubForm(id, hardDelete) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/Forms/DeleteSubForm?id=${id}&hardDelete=${hardDelete}`, {headers});
}

export function getLevelMetrics(companyId, eventId, includeDeleted) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Forms/GetLevelMetrics?companyId=${companyId}&eventId=${eventId}&includeDeleted=${includeDeleted}`, {headers});
}



// WEBPACK FOOTER //
// ./src/services/Forms.service.js